module.exports = __webpack_public_path__ + "img/9d720f0.jpg";